import logo from "../assests/2k_logo.png";
import addProduct from "../assests/newProduct.png";
import viewProduct from "../assests/viewProduct.png";
import newPurchase from "../assests/newPurchase.png";
import viewPurchase from "../assests/viewPurchase.png";
import viewExe from "../assests/viewExe.png";
import newExe from "../assests/newExe.png";
import customers from "../assests/customer.png";
import newOrder from "../assests/newOrd.png";
import viewOrder from "../assests/viewOrd.png";
import dashboard from "../assests/dashboard.png";
import profile from "../assests/profile.png";
import logout from "../assests/logout.png";
import userProfile from "../assests/userIcon.png";
import backIcon from "../assests/backIcon.png";
import deleteIcon from "../assests/deleteIcon.png";
import downloadIcon from "../assests/downloadIcon.png";
import repeatOrder from "../assests/repeatOrder.png";
import orderAdd from "../assests/orderAdd.png";

const Images = {
  logo: logo,
  addProduct: addProduct,
  viewProduct,
  newPurchase,
  viewPurchase,
  viewExe,
  newExe,
  customers,
  newOrder,
  viewOrder,
  dashboard,
  profile,
  logout,
  userProfile,
  backIcon,
  deleteIcon,
  downloadIcon,
  repeatOrder,
  orderAdd,
};
export default Images;
